export const selectedCCfromSF = {
  2  : 'ECONOMY',
  3  : 'MIDSIZE',
  4  : 'FULLSIZE',
  5  : 'COMPACT',
  6  : 'STANDARD',
  7  : 'LUXURY',
  8  : 'MINIVAN',
  9  : 'PREMIUM',
  11 : 'SUV',
  12 : 'CONVERTIBLE',
  15 : 'SPORTSCAR'
};
